import addComponentLoader, { addSharedStoreComponentLoader, importWithRetry } from '@/utils/component-loader'
import { defineAsyncComponent } from 'vue'

// Components for the petition page. These all share a single vuex store.
const petitionPageComponentsMapping = {
  petitionSign: defineAsyncComponent(() => importWithRetry(() => import('./sign/root'))),
  petitionCommentsList: defineAsyncComponent(() => importWithRetry(() => import('./comments/comments-list'))),
  petitionPromptsBanner: defineAsyncComponent(() => importWithRetry(() => import('../campaign-prompts/petition-root'))),
  petitionImageUploadAndCrop: defineAsyncComponent(() => importWithRetry(() => import('./upload-and-crop'))),
  petitionCategoriesSetter: defineAsyncComponent(() => importWithRetry(() => import('./categories-setter')))
}

// Component for the embedded signature form
const embeddedComponentsMapping = {
  embeddedPetitionSign: defineAsyncComponent(() => importWithRetry(() => import('./sign/embedded-form')))
}

// Component used on the single-comment page, with no vuex store
const independentCommentsMapping = {
  petitionComment: defineAsyncComponent(() => importWithRetry(() => import('./comments/comment')))
}

// The 'petitionSign' for the last argument here means that the storeData of the petitionSign component
// will be used to initialize the store state.
addSharedStoreComponentLoader(petitionPageComponentsMapping, {}, () => importWithRetry(() => import('./store')), 'petitionSign')

addComponentLoader(embeddedComponentsMapping, {}, () => importWithRetry(() => import('./store')))
addComponentLoader(independentCommentsMapping, {})
